import Constants from 'arts/config/constants';
import { loadCollectionDetailsApi } from 'arts/config/api';

export const loadCollectionDetails = (slug) => (dispatch) => {
  dispatch({ type: Constants.CollectionDetails.LOAD, slug });
  loadCollectionDetailsApi(slug).then((item) => {
    dispatch({ type: Constants.CollectionDetails.LOADED, item, slug });
  }).catch(() => {});
};
